"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyPartPicker = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const renderChildren_1 = require("../utils/renderChildren");
const types_1 = require("./types");
const hooks_1 = require("./hooks");
const pickers_1 = require("./pickers");
const BodyPartPicker = (0, react_1.forwardRef)((_a, ref) => {
    var { bodyParts = [], className, children, disabled, gender = types_1.BodyPartPickerGender.Male, onClick, readOnly, side = types_1.BodyPartPickerSide.Front } = _a, props = __rest(_a, ["bodyParts", "className", "children", "disabled", "gender", "onClick", "readOnly", "side"]);
    const { side: currentSide, nextSideValue, gender: currentGender, nextGenderValue, selectedBodyParts, switchToFemale, switchToMale, switchGender, setSide, switchSide, setGender, handleBodyPartClick, clearParts, } = (0, hooks_1.useBodyParts)({
        defaultSide: side,
        defaultGender: gender,
        bodyParts,
    });
    (0, react_1.useEffect)(() => {
        if (side !== currentSide) {
            setSide(side);
        }
    }, [side]);
    (0, react_1.useEffect)(() => {
        if (gender !== currentGender) {
            setGender(gender);
        }
    }, [gender]);
    const handleClick = (e) => {
        const newParts = handleBodyPartClick(e);
        if (onClick)
            onClick(e, newParts);
    };
    const classes = (0, classnames_1.default)(className, "gerudo-body-part-picker", currentGender, { disabled, readOnly });
    return (react_1.default.createElement("div", Object.assign({ role: "group", className: classes, ref: ref }, props),
        react_1.default.createElement("div", null,
            react_1.default.createElement(pickers_1.PartsPicker, { disabled: disabled || readOnly, gender: currentGender, side: currentSide, selectedBodyParts: selectedBodyParts, onBodyPartClick: handleClick })),
        (0, renderChildren_1.renderChildren)(children, {
            clearParts,
            switchGender,
            switchToMale,
            switchToFemale,
            setSide,
            switchSide,
            currentSide,
            currentGender,
            nextSideValue,
            nextGenderValue,
        })));
});
exports.BodyPartPicker = BodyPartPicker;
BodyPartPicker.displayName = "BodyPartPicker";
exports.default = BodyPartPicker;
//# sourceMappingURL=BodyPartPicker.js.map